import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import App from "./App";

import "materialize-css";
import "materialize-css/dist/css/materialize.css";

import "prismjs";
import "prismjs/themes/prism.css";

ReactDOM.render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js